export default {"src":"/_next/static/media/plants.85cf6f89.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};